const css = `._matchDate_1kotw_1,
._matchType_1kotw_2,
._matchOutcome_1kotw_3 {
  display: flex;
  font-size: 0.8em;
  gap: 4px;
}

._matchOutcome_1kotw_3 {
  justify-content: center;
}

._matchDate_1kotw_1 {
  justify-content: end;
  text-align: right;
}

._sportsCard_1kotw_18 {
  background-color: var(--bg-color);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  display: grid;
}
._sportsCardList_1kotw_24 {
  margin: 0;
  padding: 0;
  list-style: none;
}
._sportsCardList_1kotw_24 li {
  border-bottom: 1px solid var(--border-color);
  list-style: none;
  padding: 8px 0;
}
._sportsCardList_1kotw_24 li:last-child {
  border-bottom: 0 none transparent;
}
._sportsCardBody_1kotw_37, ._sportsCardFooter_1kotw_37 {
  border-bottom: 1px solid var(--border-color);
}
._sportsCardBody_1kotw_37:last-child, ._sportsCardFooter_1kotw_37:last-child {
  border-bottom: 0 none transparent;
}
._sportsCardHeader_1kotw_43 {
  background-position: 50% 50%;
  background-size: cover;
  border-bottom: 4px solid var(--brand-color);
  border-radius: 4px 4px 0 0;
  overflow: hidden;
  padding: 16px;
}
._sportsCardHeader_1kotw_43[data-brand-profiling=background] {
  background-color: var(--brand-color);
}
._sportsCardHeaderContents_1kotw_54 {
  align-items: center;
  column-gap: 16px;
  display: grid;
  grid-template-areas: "DisplayPic Title" "Record ." "OtherInfo ." "From From";
  grid-template-columns: 48px auto;
}
._sportsCardHeaderContents_1kotw_54 > * {
  margin-bottom: 16px;
}
._sportsCardHeaderContents_1kotw_54 > *:last-child {
  margin-bottom: 0;
}
._sportsCardHeaderContents_1kotw_54[data-type=scores] {
  column-gap: 8px;
  grid-template-areas: "DisplayPic Title Scores" "Record Record ." "OtherInfo OtherInfo ." "From From From";
}
._sportsCardHeaderContents_1kotw_54[data-type=scores] > * {
  margin-bottom: 8px;
}
._sportsCardHeaderContents_1kotw_54[data-type=scores] > *:last-child {
  margin-bottom: 0;
}
._sportsCardHeaderContents_1kotw_54[data-display-pic-size=small] {
  grid-template-columns: 32px auto;
}
._sportsCardHeaderContents_1kotw_54[data-display-pic-size=small][data-type=scores] {
  grid-template-columns: 32px auto 36px;
}
._sportsCardHeaderContents_1kotw_54[data-display-pic-size=medium] {
  grid-template-columns: 48px auto;
}
._sportsCardHeaderContents_1kotw_54[data-display-pic-size=medium][data-type=scores] {
  grid-template-columns: 48px auto 48px;
}
._sportsCardHeaderContents_1kotw_54[data-display-pic-size=large] {
  grid-template-columns: 64px auto;
}
._sportsCardHeaderContents_1kotw_54[data-display-pic-size=large][data-type=scores] {
  grid-template-columns: 64px auto 64px;
}
._sportsCardHeaderContentsDisplayPic_1kotw_95 {
  grid-area: DisplayPic;
}
._sportsCardHeaderContentsDisplayPic_1kotw_95[data-display-pic-by-type=players] img, ._sportsCardHeaderContentsDisplayPic_1kotw_95[data-display-pic-by-type=scores] img {
  background-color: white;
  border: 2px solid var(--brand-color);
  border-radius: 50%;
  overflow: hidden;
  width: calc(100% - 4px);
}
._sportsCardHeaderContentsTitle_1kotw_105 {
  align-items: center;
  color: var(--text-color);
  display: grid;
  grid-area: Title;
  gap: 8px;
  color: var(--text-color);
}
._sportsCardHeaderContentsTitle_1kotw_105 span._description_1kotw_113 {
  color: var(--secondary-text-color);
  font-size: 0.8em;
}
._sportsCardHeaderContentsTitleEntity_1kotw_117 {
  font-size: 1em;
  font-weight: 500;
}
@media (max-width: 767px) {
  ._sportsCardHeaderContentsTitleEntity_1kotw_117[data-entity-by-type=scores] {
    font-size: 0.8em;
  }
}
._sportsCardHeaderContentsScores_1kotw_126 {
  grid-area: Scores;
}
._sportsCardHeaderContentsScores_1kotw_126[data-scores-value=W] {
  --bg-color: var(--success-color);
  --border-color: var(--success-color);
  --text-color: white;
}
._sportsCardHeaderContentsScores_1kotw_126[data-scores-value=L] {
  --bg-color: var(--failure-color);
  --border-color: var(--failure-color);
  --text-color: white;
}
._sportsCardHeaderContentsOtherInfo_1kotw_139 {
  grid-area: OtherInfo;
}
._sportsCardHeaderContentsRecord_1kotw_142 {
  display: grid;
  grid-area: Record;
  direction: ltr;
}
._sportsCardHeaderContentsRecord_1kotw_142 [data-record-value=W] {
  --border-color: var(--success-color);
  --text-color: var(--success-color);
}
._sportsCardHeaderContentsRecord_1kotw_142 [data-record-value=L] {
  --border-color: var(--failure-color);
  --text-color: var(--failure-color);
}
._sportsCardHeaderContentsFrom_1kotw_155 {
  align-items: center;
  color: var(--text-color);
  display: grid;
  font-size: 0.8em;
  grid-area: From;
  gap: 8px;
  grid-template-areas: "Flag Place";
  grid-template-columns: auto 1fr;
}
._sportsCardHeaderContentsFrom_1kotw_155 ._flag_1kotw_165 {
  border: 1px solid var(--border-color);
  grid-area: Flag;
  height: 100%;
  width: auto;
  max-height: 16px;
}
._sportsCardHeaderContentsFromPlace_1kotw_172 {
  grid-area: Place;
}
._sportsCardHeaderContents_1kotw_54[data-home-or-away=away] {
  direction: rtl;
}
._sportsCardTopper_1kotw_178 {
  background-color: var(--border-color);
  padding: 16px;
}
._sportsCardTopper_1kotw_178 + ._sportsCardHeader_1kotw_43 {
  border-radius: 0;
}
._sportsCardBody_1kotw_37 {
  padding: 16px;
  position: relative;
}
._sportsCardBodyOtherInfo_1kotw_189, ._sportsCardBodyPlayers_1kotw_189 {
  display: grid;
  gap: 16px;
}
._sportsCard_1kotw_18 ._events_1kotw_193 {
  display: flex;
  flex-direction: column;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._event_1kotw_193[data-match-prominence] {
  margin-bottom: 16px;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._event_1kotw_193[data-match-prominence]:before {
  content: attr(data-match-prominence);
  display: block;
  font-size: 0.8em;
  font-weight: 500;
  margin-bottom: 4px;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._event_1kotw_193[data-match-prominence] > ._eventRow_1kotw_207 {
  border-top: 1px solid var(--border-color);
  border-bottom: 1px solid var(--border-color);
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRow_1kotw_207 {
  border: 1px solid var(--border-color);
  border-bottom: 0 none transparent;
  display: grid;
  font-size: 0.8em;
  grid-template-areas: "MatchType Home HomeScore AwayScore Away WinType Round";
  grid-template-columns: 1fr 3fr 1fr 1fr 3fr 1fr 1fr;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRow_1kotw_207 > * {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 8px;
}
@media (min-width: 768px) {
  ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRow_1kotw_207 > * {
    border-right: 1px solid var(--border-color);
  }
  ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRow_1kotw_207 > *:last-child {
    border-right: 0 none transparent;
  }
}
@media (max-width: 767px) {
  ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRow_1kotw_207 {
    grid-template-areas: "MatchType Home HomeScore WinType" "MatchType Away AwayScore Round";
    grid-template-columns: 1fr 3fr 1fr 1fr;
  }
  ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowMatchType_1kotw_238, ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHome_1kotw_238, ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAway_1kotw_238, ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHomeScore_1kotw_238, ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAwayScore_1kotw_238 {
    border-right: 1px solid var(--border-color);
  }
  ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAway_1kotw_238 {
    justify-content: start;
  }
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHome_1kotw_238, ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAway_1kotw_238 {
  display: grid;
  gap: 4px;
  grid-template-columns: 1fr 28px;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHomeFlag_1kotw_250, ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAwayFlag_1kotw_250 {
  border: 1px solid var(--border-color);
  height: 100%;
  width: auto;
  max-height: 16px;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowDisplayPic_1kotw_256 {
  background-color: var(--brand-color);
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowMatchType_1kotw_238 {
  grid-area: MatchType;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHome_1kotw_238 {
  grid-area: Home;
  justify-content: start;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHomeScore_1kotw_238 {
  grid-area: HomeScore;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowWinType_1kotw_269 {
  grid-area: WinType;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowRound_1kotw_272 {
  grid-area: Round;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAwayScore_1kotw_238 {
  grid-area: AwayScore;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAway_1kotw_238 {
  grid-area: Away;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHomeScore_1kotw_238, ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAwayScore_1kotw_238 {
  background-color: var(--bg-color);
  color: var(--text-color);
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHomeScore_1kotw_238[data-scores-value=W], ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAwayScore_1kotw_238[data-scores-value=W] {
  --bg-color: var(--success-color);
  --border-color: var(--success-color);
  --text-color: white;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHomeScore_1kotw_238[data-scores-value=D], ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAwayScore_1kotw_238[data-scores-value=D] {
  font-style: italic;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHomeScore_1kotw_238[data-scores-value=NC], ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAwayScore_1kotw_238[data-scores-value=NC] {
  --text-color: var(--border-color);
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowHome_1kotw_238[data-scores-value=W], ._sportsCard_1kotw_18 ._events_1kotw_193 ._eventRowAway_1kotw_238[data-scores-value=W] {
  border: 2px solid var(--success-color);
  padding: 4px 8px;
}
._sportsCard_1kotw_18 ._events_1kotw_193 ._event_1kotw_193:last-child > ._eventRow_1kotw_207 {
  border-bottom: 1px solid var(--border-color);
}
._sportsCard_1kotw_18 ._player_1kotw_303 {
  align-items: center;
  display: grid;
  grid-template-columns: 32px auto 48px;
}
._sportsCard_1kotw_18 ._player_1kotw_303 > span {
  font-size: 0.8em;
}
._sportsCard_1kotw_18 ._otherInfo_1kotw_311 {
  display: grid;
  gap: 8px;
  font-size: 0.8em;
}
._sportsCard_1kotw_18 ._otherInfoHeading_1kotw_316 {
  font-weight: 500;
}
._sportsCard_1kotw_18 ._stickyButton_1kotw_319 {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "matchDate": "_matchDate_1kotw_1",
  "matchType": "_matchType_1kotw_2",
  "matchOutcome": "_matchOutcome_1kotw_3",
  "sportsCard": "_sportsCard_1kotw_18",
  "sportsCardList": "_sportsCardList_1kotw_24",
  "sportsCardBody": "_sportsCardBody_1kotw_37",
  "sportsCardFooter": "_sportsCardFooter_1kotw_37",
  "sportsCardHeader": "_sportsCardHeader_1kotw_43",
  "sportsCardHeaderContents": "_sportsCardHeaderContents_1kotw_54",
  "sportsCardHeaderContentsDisplayPic": "_sportsCardHeaderContentsDisplayPic_1kotw_95",
  "sportsCardHeaderContentsTitle": "_sportsCardHeaderContentsTitle_1kotw_105",
  "description": "_description_1kotw_113",
  "sportsCardHeaderContentsTitleEntity": "_sportsCardHeaderContentsTitleEntity_1kotw_117",
  "sportsCardHeaderContentsScores": "_sportsCardHeaderContentsScores_1kotw_126",
  "sportsCardHeaderContentsOtherInfo": "_sportsCardHeaderContentsOtherInfo_1kotw_139",
  "sportsCardHeaderContentsRecord": "_sportsCardHeaderContentsRecord_1kotw_142",
  "sportsCardHeaderContentsFrom": "_sportsCardHeaderContentsFrom_1kotw_155",
  "flag": "_flag_1kotw_165",
  "sportsCardHeaderContentsFromPlace": "_sportsCardHeaderContentsFromPlace_1kotw_172",
  "sportsCardTopper": "_sportsCardTopper_1kotw_178",
  "sportsCardBodyOtherInfo": "_sportsCardBodyOtherInfo_1kotw_189",
  "sportsCardBodyPlayers": "_sportsCardBodyPlayers_1kotw_189",
  "events": "_events_1kotw_193",
  "event": "_event_1kotw_193",
  "eventRow": "_eventRow_1kotw_207",
  "eventRowMatchType": "_eventRowMatchType_1kotw_238",
  "eventRowHome": "_eventRowHome_1kotw_238",
  "eventRowAway": "_eventRowAway_1kotw_238",
  "eventRowHomeScore": "_eventRowHomeScore_1kotw_238",
  "eventRowAwayScore": "_eventRowAwayScore_1kotw_238",
  "eventRowHomeFlag": "_eventRowHomeFlag_1kotw_250",
  "eventRowAwayFlag": "_eventRowAwayFlag_1kotw_250",
  "eventRowDisplayPic": "_eventRowDisplayPic_1kotw_256",
  "eventRowWinType": "_eventRowWinType_1kotw_269",
  "eventRowRound": "_eventRowRound_1kotw_272",
  "player": "_player_1kotw_303",
  "otherInfo": "_otherInfo_1kotw_311",
  "otherInfoHeading": "_otherInfoHeading_1kotw_316",
  "stickyButton": "_stickyButton_1kotw_319"
};